import moment from 'moment';

const getGiveawayByIdResponse = (response) => {
  const giveawayData = response?.data?.giveaway;
  const giveaways = giveawayData?.giveaways?.map((giveaway) => {
    return {
      ...giveaway,
      sessions: giveaway?.sessions?.map((session) => {
        return {
          ...session,
          promotionDate: moment(session?.promotionDate).format('DD MMMM YY'),
          showTime: `${session?.startTime?.slice(0, 5)} - ${session?.endTime?.slice(0, 5)}`,
        };
      }),
    };
  });
  return {
    ...giveawayData,
    title: giveawayData?.title ? giveawayData?.title : '-',
    giveaways,
  };
};

export default getGiveawayByIdResponse;
